import { useEffect, useState } from "react";
import SidebarManager from "../components/SidebarManager.js";
import Header from "../components/Header.js";
import NumCard from "../components/NumCard.js";
import CreateCompanyProfile from "../components/CreateCompanyProfile.js";
import Table from "../components/Table.js";
import { getCompanyDetails } from "../services/companyService.js";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext.js";

function Companies() {
  const { user } = useAuth();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [stats, setStats] = useState({
    totalCompanies: 0,
    assignedForms: 0,
  });

  const [companies, setCompanies] = useState([]);

  const fetchCompanies = async () => {
    try {
      setLoading(true);
      //const response = await fetch("/api/company/detail");
      const response = await getCompanyDetails(user);
      //const data = await response.json();
      const filteredResponse =
        user.userRole.id === 1
          ? response
          : response.filter((x) => x.manager.userId === user.id);
      setCompanies(filteredResponse);
      setLoading(false);
      setStats((x) => ({
        ...x,
        totalCompanies: filteredResponse.length,
        assignedForms: filteredResponse.filter(
          (y) => y.assignedValidators.length > 0
        ).length,
      }));
    } catch (error) {
      setLoading(false);
      console.error("Failed to load company data:", error);
    }
  };

  const fetchStats = async () => {
    try {
      const response = await fetch("/api/dashboard-stats");
      const data = await response.json();
      setStats(data);
    } catch (error) {
      console.error("Failed to fetch stats:", error);
    }
  };

  useEffect(() => {
    fetchCompanies();
    // fetchStats(); // Uncomment when API is ready
  }, []);

  const redirectToForm = (row) => {
    navigate(`/assign-forms?companyId=${row.companyId}`);
  };

  const today = new Date().toLocaleDateString("en-GB", {
    weekday: "long",
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  const columns = [
    { label: "Company Name", key: "name" },
    { label: "Registered Name", key: "registeredName", align: "start" },
    { label: "Website", key: "websiteUrl", align: "start" },
    {
      label: "Industries",
      key: "industries",
      align: "center",
      format: "arrayValue",
    },
    {
      label: "Onboarded on",
      key: "createdAt",
      align: "center",
      format: "date",
    },
    {
      label: "Assign Status",
      key: "assignedValidators",
      align: "center",
      render: (row) => (
        <span
          className={`text-white px-4 py-1 rounded-lg text-sm hover:opacity-90 ${
            row.assignedValidators.length === 0 ? "bg-red-500" : "bg-green-500"
          }`}
          onClick={() => redirectToForm(row)}
        >
          {row.assignedValidators.length === 0 ? "Unassigned" : "Assigned"}
        </span>
      ),
    },
    {
      label: "Action",
      key: "action",
      align: "center",
      render: (row) => (
        <button
          className="bg-[#6f81f5] text-white px-4 py-1 rounded-lg text-sm hover:opacity-90 cursor-pointer"
          onClick={() => redirectToForm(row)}
        >
          Assign
        </button>
      ),
    },
  ];

  return (
    <div className="py-8 px-[5rem] bg-[#fbfbfb] w-screen mx-auto">
      <Header title="Assign Forms" date={today} />

      {/* Stats and Create Company Profile Section */}
      <div className="flex w-full gap-4 items-stretch mb-10">
        <div className="grid grid-cols-2 gap-4 flex-1">
          <NumCard
            amount={stats.totalCompanies}
            text="Total Forms"
            colour="#6f81f5"
            height="h-[100%]"
            width="w-full"
          />
          <NumCard
            amount={stats.assignedForms}
            text="Assigned Forms"
            colour="#595959"
            height="h-[100%]"
            width="w-full"
          />
        </div>

        <div className="bg-gradient-to-br from-white to-[#f0f4ff] rounded-2xl shadow border px-6 py-6 flex flex-col justify-between w-[300px]">
          <div>
            <h3 className="text-lg font-semibold mb-1">
              Create Company Profiles
            </h3>
            <p className="text-sm text-gray-500">
              Company Profiles can be assigned to validators
            </p>
          </div>
          <div className="mt-4 text-right">
            <button
              className="bg-[#6f81f5] text-white px-4 py-2 rounded-lg hover:opacity-90 text-sm cursor-pointer"
              onClick={(e) => {
                e.preventDefault();
                navigate("/company-profile");
              }}
            >
              Create profile →
            </button>
          </div>
        </div>
      </div>

      {/* Company Table Section */}
      <div className="mb-8">
        <h2 className="text-xl font-semibold mb-2">Companies</h2>
        <p className="text-sm mb-4 text-gray-500">
          Total: {companies.length} Numbers
        </p>
        <Table
          columns={columns}
          rows={companies}
          colour="#c5cdfb"
          loading={loading}
        />
      </div>
    </div>
  );
}

export default Companies;
